export enum NavigationEnum {
    Forward,
    Back,
    Root
}
